import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStageMap } from "../../config/applicationStatusConfig";

const DDOApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="DDO Applications"
        status={[]}
        stage={[applicationStageMap?.ddo.value]}
      />
    </DashboardLayout>
  );
};

export default DDOApplications;
